module.exports = __webpack_public_path__ + "img/icon-share.7ae728ce.svg";